/**
* 用户管理 用户列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >管理</el-breadcrumb-item>
      <!-- :to="{ path: '/' }" -->
      <el-breadcrumb-item>自定义设置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id" >
        <!-- <el-table-column  prop="id" label="编号" width="80">
        </el-table-column> -->
        <el-table-column align="center" prop="issue" label="问题">
        </el-table-column>
        <el-table-column align="center" prop="content" label="颜色值 / 内容(未设置会生效默认值)">
            <template slot-scope="scope">  
                <div :style="'background-color:'+scope.row.content">{{ scope.row.content }}</div>
            </template>
        </el-table-column>
        <!-- <el-table-column width="150px" prop="createTime"  label="创建时间">
        </el-table-column> -->
        
        <el-table-column align="center" label="操作" width="400px">
            <template slot-scope="scope">
              <input v-model="scope.row.content" placeholder="输入"></input>
              <el-button size="mini" type="primary"
                  @click="updates(scope.$index, scope.row)">
                  保存
              </el-button>
              
            </template>
        </el-table-column>
    </el-table>



  </div>
</template>

<script>
import { addCustomize , deleteCustomize , getCustomizeList , updateCustomize } from '../../../api/manage/customize.js'

import moment from 'moment';

export default {
  data() {
    return {
        totalnum:0,
        page : 1 ,
        size : 10,
        tableData:[],
        tableData2:[],

    }
  },
  components: {

  },

  created() {
    this.dataSelect()
    // this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    updates(index,row){
        let post= row
        updateCustomize(post).then((res) => {
          this.tableDataLoading = false
          if (res.code == 200) {
              this.$message({
              type: "success",
              message: res.msg,
              duration: 1500,
              onClose: () => {
                this.dataSelect()
              }
            });
          }
          
       })
    },

    dataSelect(){
      let post = {
        page : (this.page - 1 ) * this.size,
        size : this.size
      }
      this.tableDataLoading = true
      getCustomizeList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
          this.tableData = res.data.data
          return;
        }
        this.$message({
            type: "info",
            message: res.msg,
        });
      })
    },
  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/customize/index.vue